export enum ReadingScreenTheme {
  DEFAULT = 1,
  GREEN = 2,
  BROWN = 3,
  DARK = 4,
}

export const BgScreenThemeClass = Object.freeze({
  [ReadingScreenTheme.DEFAULT]: "bg-[#F5F2EE]",
  [ReadingScreenTheme.GREEN]: "bg-[#ABC2BA]",
  [ReadingScreenTheme.BROWN]: "bg-[#E0DCCE]",
  [ReadingScreenTheme.DARK]: "bg-[#171A20] text-white",
});
